import { ObjectMapper } from 'json-object-mapper';
import { IModel } from '../IModel';
import { Model } from '../model';

export class OcrHiringSettingsModel extends Model implements IModel<OcrHiringSettingsModel> {
  public companyGroupId: string = '';
  public validateImageQuality: boolean = true;

  static create(input: any): OcrHiringSettingsModel {
    return ObjectMapper.deserialize<OcrHiringSettingsModel>(OcrHiringSettingsModel, input);
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }
}
